import { render, staticRenderFns } from "./PricePageDescription.vue?vue&type=template&id=956d1d1e&scoped=true&"
import script from "./PricePageDescription.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PricePageDescription.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PricePageDescription.vue?vue&type=style&index=0&id=956d1d1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956d1d1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('956d1d1e')) {
      api.createRecord('956d1d1e', component.options)
    } else {
      api.reload('956d1d1e', component.options)
    }
    module.hot.accept("./PricePageDescription.vue?vue&type=template&id=956d1d1e&scoped=true&", function () {
      api.rerender('956d1d1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceHeader/PricePageDescription.vue"
export default component.exports